// extracted by mini-css-extract-plugin
export default {"button":"ContentButton__button--lc-Z1CeX","link":"ContentButton__link--lc-PyTjk","bonus":"ContentButton__bonus--lc-ZDBhB","game":"ContentButton__game--lc-Vfwsb"};